export default {
    accountTagsDeleteTags_title: "Delete Tags",
    accountTagsDeleteTags_deleteWarning: "Are you sure you want delete the following tags?",
    accountTagsDeleteTags_errorSelectTag: "You can not select a tag that will be delete",
    accountTagsDeleteTags_typeToSearch: "Type to search...",
    accountTagsDeleteTags_selectTag: "Move the nested tags and entities to",
    accountTagsDeleteTags_deleted: "Tags deleted successfully",
};